import { Link } from "react-router-dom";
import { Leaf, Instagram, Facebook, Linkedin, Mail, MapPin } from "lucide-react";
import { CONTACT } from "@/data/content";

const quickLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const services = [
  "Hydroponics Consultancy",
  "Polyhouse Construction",
  "Farm Management",
  "Agronomy Advisory",
  "Training",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-background">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-2">
              <span className="grid place-items-center w-9 h-9 overflow-hidden">
                <img
                  src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEilBpMp_L3hl1Sgf1n2B6h8tgCol5s9clcPSv0b6qV6A9TxPONnb7wrQhQ58_3u4v1bPFXDKMMhEwxMR8uhaX3mrpp1rBpp6mR8RKsSMV9JmUbDN00E7y46oiQYNooQfygIBEkA5leFZ5CXKxHeW5Sv-80muZfIO66rIMgs8IgjHCl3eq3hSNjAamJGfOc/s1600/Blue%20Minimalist%20Circle%20Framed%20Instagram%20Profile%20Picture.png"
                  alt="FarmingWave logo"
                  className="w-full h-full object-cover"
                />
              </span>
              <span className="font-clash font-semibold text-lg tracking-tight">
                Farming<span className="text-primary">Wave</span>
              </span>
            </Link>
            <p className="mt-6 text-muted-foreground max-w-xs leading-relaxed">
              Pioneers of agronomy services in India. Growing Smarter. Growing Together.
            </p>
            <div className="mt-6 flex gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="grid place-items-center w-10 h-10 border border-border text-muted-foreground hover:text-primary hover:border-primary transition-colors duration-300"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-primary">Quick Links</p>
            <ul className="mt-5 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-primary">Services</p>
            <ul className="mt-5 space-y-3">
              {services.map((s) => (
                <li key={s} className="text-muted-foreground">
                  {s}
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline text-primary">Get in Touch</p>
            <ul className="mt-5 space-y-4">
              <li className="flex items-start gap-2 text-muted-foreground">
                <Mail className="w-4 h-4 mt-1 shrink-0 text-primary" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-foreground break-all">
                  {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-2 text-muted-foreground">
                <MapPin className="w-4 h-4 mt-1 shrink-0 text-primary" />
                {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="overline text-muted-foreground">
            © 2026 FarmingWave. All Rights Reserved.
          </p>
          <p className="overline text-muted-foreground">Growing Smarter · Growing Together</p>
        </div>
      </div>
    </footer>
  );
}
